import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { Inter, Manrope, Indie_Flower } from "next/font/google";
import Head from "next/head";
import { ThemeProviderWrapper } from "@/components/providers/ThemeProviderWrapper";
import ThemeToggle from "@/components/common/ThemeToggle";
import PlausibleProvider from 'next-plausible'


const inter = Inter({ 
  subsets: ["latin"],
  variable: "--font-inter",
  display: "swap",
});

const manrope = Manrope({
  subsets: ["latin"],
  variable: "--font-manrope",
  display: "swap",
});

const indieFlower = Indie_Flower({
  weight: ["400"],
  subsets: ["latin"],
  variable: "--font-indie-flower",
  display: "swap",
});

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/icons/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/icons/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/icons/favicon-16x16.png"
        />
      </Head>
      <PlausibleProvider domain="amrik.live">
      <ThemeProviderWrapper>
        <div className={`${inter.variable} ${manrope.variable} ${indieFlower.variable} font-sans`}>
          <Component {...pageProps} />
          <ThemeToggle />
        </div>
      </ThemeProviderWrapper>
      </PlausibleProvider>
    </>
  );
}
